export default __webpack_public_path__ + "static/media/salame store.fbb3af09.jpeg";